import { render, staticRenderFns } from "./pos-add-badge-modal.vue?vue&type=template&id=4f780970&scoped=true&"
import script from "./pos-add-badge-modal.vue?vue&type=script&lang=ts&"
export * from "./pos-add-badge-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f780970",
  null
  
)

export default component.exports